import { ReactNode, useId } from 'react'

import { FormGroup } from './FormGroup'

export type LabelStyle = 'floating' | 'static' | 'plain'

export type FieldProps = {
  label?: ReactNode
  error?: string
  hint?: ReactNode
  labelStyle?: LabelStyle
  className?: string
  style?: React.CSSProperties
  id?: string
}

const LABEL_STYLE_CLASSES: Readonly<Record<LabelStyle, string>> = {
  floating: 'label-floating',
  static: 'label-static',
  plain: '',
}

export function Field({
  label,
  error,
  hint,
  labelStyle = 'floating',
  className = '',
  style,
  controlId,
  children,
}: FieldProps & { controlId: string; children: ReactNode }) {
  const groupClasses = ['form-group', LABEL_STYLE_CLASSES[labelStyle], error ? 'has-error has-danger' : '', className]
    .filter((part) => part !== '')
    .join(' ')

  return (
    <FormGroup className={groupClasses} style={style}>
      {label && (
        // Material Kit floats and positions a label only through `control-label`,
        // so every style needs it — `labelStyle` picks the group class alone.
        <label className="control-label" htmlFor={controlId}>
          {label}
        </label>
      )}
      {children}
      {(error ?? hint) && <div className="help-block with-errors">{error ?? hint}</div>}
    </FormGroup>
  )
}

export function useControlId(explicit: string | undefined): string {
  const generated = useId()
  return explicit ?? generated
}
